import { VoidCallback } from '@deqo/foundation';
import React, { useCallback, useState } from 'react';
import { Icon } from '../../../concepts/resources/Icon';
import { HeaderButton } from '../../../ui/HeaderButton';
import { Tip } from '../../../ui/Tip';
import { useResolve } from '../../Container';
import { useDashboardVersion } from '../../account/AccountHooks';
import { AccountModel } from '../../account/AccountModel';
import { Page } from '../../common/Page';
import { ShowIfHasPermission } from '../../common/PermissionElements';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { BoardInfo } from '../BoardInfo';
import { EditorSession } from '../EditorSession';
import { createObserver } from '../ExtendableStore';
import { Popover } from '../ui/Popover';
import { NextShareView } from './NextShareView';
import { ShareView } from './ShareView';

const BoardInfoObserver = createObserver(BoardInfo);

const selectIcon = (account: AccountModel, { viewers }: BoardInfo) => {
    if (account.plan.features.accessControl) {
        if (viewers === 'workspace') return 'deqo://icons/hero/lock-closed';
        if (viewers === 'account') return 'deqo://icons/hero/lock-open';
    }
    return 'deqo://icons/i8/globe';
};

const ShareViewSelector = ({ onClose }: { onClose: VoidCallback }) => {
    const version = useDashboardVersion();
    return <Flexer id="share-view" padding="0">
        {version === 'next' && <NextShareView onDismiss={onClose} />}
        {version !== 'next' && <ShareView onDismiss={onClose} />}
    </Flexer>;
};

export const ShareButton = () => {

    const account = useResolve(AccountModel);
    const session = useResolve(EditorSession);

    const [open, setOpen] = useState(false);
    const onClose = useCallback(() => setOpen(false), []);

    return <Popover
        content={<ShareViewSelector onClose={onClose} />}
        open={open}
        onOpenChange={setOpen}
        placement="bottom-end"
        inner={{ direction: 'down' }}
    >
        <Tip text="Sharing &amp; Permissions" position="bottom" disabled={open}>
            <HeaderButton data-tour="share" data-action="editor.openSharing" active={open}>
                <BoardInfoObserver store={session} render={x => <Icon size="1.2" src={selectIcon(account, x)} />} />
                <span>Share</span>
            </HeaderButton>
        </Tip>
    </Popover>;
};

export const ShareHeaderBlock = () =>
    <ShowIfHasPermission requires={['wo:read', 'da:write', 'bo:write']}>
        <Page.HeaderBlock>
            <ShareButton />
        </Page.HeaderBlock>
    </ShowIfHasPermission>;
